import common from './common'
import index from './index'
import template from './template'
import faq from './faq'
import product from './product'
import sample from './sample'
import partials from './partials'

document.addEventListener('DOMContentLoaded', function() {
  // setViewport を DOMContentLoaded 直後に一度走らせ、--head / --headapp を
  // 実測値で先に確定させる（FCP 直後のヘッダー高さ変動による CLS を抑える）
  setViewport()

  partials().then(() => {
    common()
    index()
    template()
    faq()
    sample()
    product()
    initContactForm()
    require("fslightbox")
    window.addEventListener('resize', setViewport)
    window.addEventListener('load', setViewport)
    // mount 完了後に再度実測（Vue によるレンダリング変化を反映）
    setViewport()

    // STG用にリンクを一括チェック、置き換え（mount 直後に即実行）
    if (location.pathname.startsWith('/stg/')) {
      document.querySelectorAll('#app a[href]').forEach(function(el) {
        var href = el.getAttribute('href');
        if (href && href.startsWith('/') && !href.startsWith('/stg/')) {
          el.setAttribute('href', '/stg' + href);
        }
      });
      document.querySelectorAll('#app form[action]').forEach(function(f) {
        var action = f.getAttribute('action');
        if (action && action.startsWith('/') && !action.startsWith('/stg/')) {
          f.setAttribute('action', '/stg' + action);
        }
      });
    }
  })
})


function initContactForm() {
  const cf_selector = 'div.wpcf7 > form'
  const cf_forms = document.querySelectorAll(cf_selector)
  if (cf_forms.length === 0) return

  // spinner は即時削除（CLS を避けるため）
  const cf_load = document.querySelector('.wpcf7-spinner')
  if (cf_load) cf_load.remove()

  // window.wpcf7 は CF7 プラグインのスクリプト読み込み完了後に定義される。
  // 未定義なら読み込み完了まで rAF で待機（最大 60 フレーム ≒ 1 秒）。
  let attempts = 0
  const tryInit = () => {
    if (window.wpcf7 && typeof window.wpcf7.init === 'function') {
      window.wpcf7.init(cf_forms[0])
      return
    }
    if (attempts++ < 60) {
      requestAnimationFrame(tryInit)
    }
  }
  tryInit()
}


function setViewport(){
  const vw = window.innerWidth;
  const vh = window.innerHeight * 0.01
  const headApp = document.getElementById('header-app')
  const head = document.getElementById('site-header')
  document.documentElement.style.setProperty('--vh', `${vh}px`)
  document.documentElement.style.setProperty('--vw', `${vw}px`)
  if(vw < 769){ document.documentElement.style.setProperty('--size', '10px') }
  else if(vw < 1025){ document.documentElement.style.setProperty('--size', '16px') }
  else{ document.documentElement.style.setProperty('--size', '32px') }

  if(head){
    const headSize = head.getBoundingClientRect().height
    document.documentElement.style.setProperty('--head', `${headSize}px`)
  }
  if(headApp){
    const headAppSize = headApp.getBoundingClientRect().height
    document.documentElement.style.setProperty('--headapp', `${headAppSize}px`)
  }
}
